var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMyReuqest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 95,
    viewBox: "0 0 136 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.437 95.0025H15.4688L30.6469 8.92188H135.615L120.437 95.0025Z",
    fill: "#4EBBB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5697 0.0078125H32.2162L30.6445 8.92247H67.4086L66.5697 0.0078125Z",
    fill: "#4EBBB8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.437 95.0025H15.4688L30.6469 8.92188H135.615L120.437 95.0025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5697 0.0078125H32.2162L30.6445 8.92247H67.4086L66.5697 0.0078125Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5199 3.64457C28.3842 3.145 28.3535 2.64509 28.3477 2.14553C28.3525 1.64562 28.3831 1.14605 28.5199 0.646484C28.6563 1.14605 28.687 1.64596 28.6922 2.14553C28.6863 2.64544 28.6557 3.145 28.5199 3.64457Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4638 4.52605C25.0962 4.16119 24.8199 3.74363 24.5653 3.314C24.3197 2.87886 24.0965 2.43063 23.9648 1.92969C24.3331 2.2942 24.6094 2.71177 24.8634 3.14174C25.1083 3.57722 25.3319 4.02545 25.4638 4.52605Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2643 6.8174C22.7637 6.6851 22.3155 6.46185 21.88 6.21689C21.4497 5.96263 21.0321 5.68632 20.668 5.31836C21.1689 5.44997 21.6171 5.67322 22.0523 5.91887C22.4819 6.17382 22.8994 6.44979 23.2643 6.8174Z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5058 9.90078C22.0063 10.0365 21.5064 10.0672 21.0068 10.073C20.5073 10.0679 20.0074 10.0376 19.5078 9.90078C20.0074 9.76435 20.5073 9.73368 21.0068 9.72852C21.5064 9.73437 22.0059 9.76504 22.5058 9.90078Z",
    fill: "#263238"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3854 12.9551C23.0205 13.3227 22.603 13.599 22.1733 13.8536C21.7382 14.0993 21.29 14.3225 20.7891 14.4541C21.1536 14.0862 21.5711 13.8099 22.0011 13.5556C22.4366 13.3106 22.8848 13.087 23.3854 12.9551Z",
    fill: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6748 15.1582C25.5425 15.6588 25.3192 16.107 25.0743 16.5425C24.82 16.9728 24.5437 17.3904 24.1758 17.7546C24.3074 17.2536 24.5306 16.8054 24.7763 16.3702C25.0309 15.9406 25.3072 15.5231 25.6748 15.1582Z",
    fill: "#263238"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7582 15.9199C28.8939 16.4198 28.9246 16.9194 28.9305 17.419C28.9253 17.9185 28.895 18.4184 28.7582 18.918C28.6214 18.4184 28.5911 17.9185 28.5859 17.419C28.5918 16.9194 28.6225 16.4198 28.7582 15.9199Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8164 15.0371C32.184 15.402 32.46 15.8195 32.7149 16.2492C32.9606 16.6843 33.1838 17.1325 33.3154 17.6335C32.9471 17.269 32.6712 16.8514 32.4169 16.4214C32.172 15.9856 31.9487 15.5377 31.8164 15.0371Z",
    fill: "#263238"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0117 12.748C34.5123 12.8803 34.9605 13.1036 35.396 13.3486C35.8263 13.6028 36.2439 13.8791 36.608 14.2471C36.1071 14.1155 35.6589 13.8922 35.2237 13.6466C34.7941 13.392 34.3766 13.1157 34.0117 12.748Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7773 9.6625C35.2769 9.52675 35.7768 9.49609 36.2764 9.49023C36.7759 9.4954 37.2758 9.52572 37.7754 9.6625C37.2755 9.79893 36.7759 9.82959 36.2764 9.83476C35.7765 9.82891 35.2769 9.79859 34.7773 9.6625Z",
    fill: "#263238"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8945 6.60646C34.2594 6.23885 34.6769 5.96254 35.1065 5.70794C35.5417 5.46263 35.9899 5.23903 36.4908 5.10742C36.1263 5.47538 35.7088 5.75169 35.2788 6.00595C34.8433 6.25091 34.3951 6.47416 33.8945 6.60646Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6016 4.40886C31.7339 3.90826 31.9571 3.46003 32.2021 3.02455C32.4563 2.59424 32.7326 2.17667 33.1006 1.8125C32.969 2.31344 32.7457 2.76168 32.5001 3.19681C32.2451 3.62644 31.9688 4.04401 31.6016 4.40886Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.285 95.0026H15.0915L0.15625 12.0469H105.35L120.285 95.0026Z",
    fill: "#4EBBB8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6067 62.7565C39.0214 62.7565 40.979 60.7989 40.979 58.3841C40.979 55.9693 39.0214 54.0117 36.6067 54.0117C34.1919 54.0117 32.2344 55.9693 32.2344 58.3841C32.2344 60.7989 34.1919 62.7565 36.6067 62.7565Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1692 62.7565C73.5839 62.7565 75.5415 60.7989 75.5415 58.3841C75.5415 55.9693 73.5839 54.0117 71.1692 54.0117C68.7544 54.0117 66.7969 55.9693 66.7969 58.3841C66.7969 60.7989 68.7544 62.7565 71.1692 62.7565Z",
    fill: "#263238"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1679 63.4539L59.9281 62.996C59.9061 62.9547 57.6477 58.7797 53.1028 58.7797C48.9579 58.7797 47.9475 62.7107 47.9065 62.8778L47.7838 63.3788L46.7812 63.1366L46.9018 62.6353C46.9135 62.5864 48.1335 57.7461 53.1028 57.7461C58.2834 57.7461 60.7415 62.3214 60.8435 62.5164L61.0836 62.974L60.1679 63.4539Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMyReuqest);
export default __webpack_public_path__ + "static/media/no-my-reuqest.a259b666814b14bd5885757166053807.svg";
export { ForwardRef as ReactComponent };